import React from "react";
import Image from "../../assets/images/social-res.png";
const SocialRes = () => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 w-full py-10 md:px-28 px-10">
        {/* Description */}
        <div className="my-2 py-5 md:pr-10">
          <h1
            style={{}}
            className=" font-light md:text-4xl text-2xl text-pink-600 uppercase"
          >
            objectives
          </h1>
          {/* <p className="text-[12px] text-gray-600 font-normal border-b border-b-gray-700">
          </p> */}
          <p className="text-gray-600 font-normal text-left mt-8">
            Our objective is to meet the ICT needs of our clients by working
            closely with clients to provide ICT services using a participatory
            approach on the premise that ICT systems work best when designed to
            meet users’ needs. Our technicians are trained to consult with
            clients, understand clients’ ICT needs, and assist them in
            prioritizing these needs while recommending optimum affordable
            solutions.
          </p>
        </div>
        {/* Image */}
        <div className="flex items-center justify-center  p-4">
          <img src={Image} alt="ABout Us" className="h-full" />
        </div>
      </div>
    </>
  );
};

export default SocialRes;
